export default __webpack_public_path__ + "static/media/recipe3.1185c1ce.png";